import React from 'react';
import {
  connect
} from 'react-redux';
import {
  actionCreators
} from 'homeStore';
import history from 'common/history'
import { Flex } from 'antd-mobile';
import './index.css';
import ProCard from 'component/proCard'
import HomeTitle from '../homeTitle';
const PlaceHolder = ({ className = '',data = '', ...restProps }) => (
  <div className={`${className} `} {...restProps}>
   <ProCard data={data} />
  </div>
);
class CourseBox extends React.Component{
  handleSkip(type){
    if(type==='project'){
      history.push('/course/project')
    }else if(type==='live'){
      history.push('/course/live')
    }else if(type==='experiment'){
      history.push('/course/experiment')
    }

  }
  render(){
    const { data,imgUrl} =this.props;
    let list = ''
    if(data){
      list = data.toJS()
    }
    return (
      <div>
        <div className="flex-container">
          <HomeTitle title={this.props.title} imgUrl={imgUrl?imgUrl:'title_icon1'}
          skip={()=>{this.handleSkip(this.props.type)}}/>
          <Flex wrap="wrap" justify="between">
            {list ?
              list.map((item,index)=>{
                return(
                  <PlaceHolder className={item.status===0?'inline':'none-item'} key={index} data={item}  />
                )
              }):
            <p>暂无数据</p>
            }
          </Flex>
        </div>
        <div className="course-line"></div>
      </div>
      )
  }
}


const mapState = (state) => ({

})


const mapDispatch = (dispatch) => ({

})
export default connect(mapState, mapDispatch)(CourseBox);
